import { createReducer } from '@reduxjs/toolkit'

import {
    DATES,
    CAMPAIGN_BUDGET,
    CAMPAIGN_STATES,
    CAMPAIGN_TARGETING_TYPES,
    AGGREGATION,
    FACT_TYPES,
    CAMPAIGN_NAME,
    LABELS,
    METRIC_FILTERS,
    BID_MULTIPLIERS,
} from 'const/filters'
import { FILTER_SETTINGS, LOCAL_FILTERS } from 'const/reducerKeys'

import {
    defaultResourcePageTabs,
    defaultResourcePageWidgets,
    defaultResourcePage,
} from '../defaults'

const defaultState = {
    [LOCAL_FILTERS]: {
        [CAMPAIGN_NAME]: null,
        [FACT_TYPES]: [],
        [CAMPAIGN_BUDGET]: [],
        [CAMPAIGN_STATES]: [],
        [CAMPAIGN_TARGETING_TYPES]: [],
        [LABELS]: [],
        [METRIC_FILTERS]: [],
        [BID_MULTIPLIERS]: [],
    },
    [FILTER_SETTINGS]: {
        anchored: [CAMPAIGN_NAME, DATES, AGGREGATION, FACT_TYPES],
        order: [
            CAMPAIGN_STATES,
            CAMPAIGN_BUDGET,
            CAMPAIGN_TARGETING_TYPES,
            LABELS,
            METRIC_FILTERS,
            BID_MULTIPLIERS,
        ],
        displayState: {
            [CAMPAIGN_STATES]: true,
            [CAMPAIGN_BUDGET]: false,
            [CAMPAIGN_TARGETING_TYPES]: false,
            [LABELS]: true,
            [METRIC_FILTERS]: true,
            [BID_MULTIPLIERS]: true,
        },
    },

    ...defaultResourcePage,
    tabs: defaultResourcePageTabs,
    widgets: defaultResourcePageWidgets('portfolioPage'),
}

export default createReducer(defaultState, () => {})
